import React, { useEffect, useRef, useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import Price from '../Price'
import DynamicFormControls from './DynamicFormControls'
const DynamicForm = (props) => {

   const { validated, validateForm, formState, setFormState, step, id, basketState,
      setBasketState, controls, activeIndex, listData, modelLoaded } = props
   const form = useRef()
   const { name, price } = step

   useEffect(() => {
      if (validated) {
         validateForm()
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [formState])

   const overrideSubmit = (e) => {
      e.preventDefault();
      e.stopPropagation();
   }

   return (
      <Form className='optionsForm pt-4' ref={form} id={id} noValidate validated={validated} onSubmit={overrideSubmit} >
         <Row>
            <Col xs={12}>
               <Row className='mb-4'>
                  {price ? <h3>{name} <span className='float-end'><Price {...price} /></span></h3> : null}
                  <DynamicFormControls modelLoaded={modelLoaded} listData={listData} basketState={basketState} activeIndex={activeIndex}
                     setBasketState={setBasketState} step={step} controls={controls} form={form} formState={formState} setFormState={setFormState} />
               </Row>
            </Col >
         </Row >
      </Form >
   )
}
export default DynamicForm